import React, { FC } from 'react';
import moment from 'moment';
import copy from 'copy-to-clipboard';
import toast from 'react-hot-toast';

import { useAppDispatch } from '../redux/hooks';
import { clearCurrentProject } from '../redux/reducers/project.slice';
import { ReactComponent as CopyIconSVG } from '../svg/copy-icon.svg';
import { useHistory } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

import useToggle from '../hooks/useToggle';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

type ProjectItemProps = {
  project: Project;
};

const ProjectItem: FC<ProjectItemProps> = (props) => {
  const { project } = props;
  let history = useHistory();

  const dispatch = useAppDispatch();
  const [isOpenMenu, toggleMenu] = useToggle(false);

  const imgSrc = project?.fileName
    ? `https://xyz-project-bucket.s3.us-west-2.amazonaws.com/${project?.fileName}`
    : './images/project_poster.jpeg';

  function copyProjectLink() {
    const projectLink = `${location.origin}/projects/${project.id}`;

    copy(projectLink);
    toast.success('Copied');
    toggleMenu();
  }

  return (
    <div
      className="project-item-container"
      onClick={() => {
        dispatch(clearCurrentProject());
        history.push(`/project/${project.id}`);
      }}
    >
      <div className="project-item-content">
        <div className="project-item-image">
          <img style={{ objectFit: 'cover' }} src={imgSrc} alt="" />
        </div>
        <div className="project-item-info">
          <div className="project-item-name">
            <div>{project.name}</div>
            <div>
              <Dropdown className="menu" isOpen={isOpenMenu} toggle={toggleMenu}>
                <DropdownToggle data-toggle="dropdown" tag="span">
                  <FontAwesomeIcon
                    className="menu-icon"
                    icon={faEllipsisV}
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleMenu();
                    }}
                  />
                </DropdownToggle>
                <DropdownMenu right className="menu-item-container">
                  <div
                    className="menu-item"
                    onClick={(e) => {
                      e.stopPropagation();
                      copyProjectLink();
                    }}
                  >
                    <span>Copy Share Link</span>
                  </div>
                  <div
                    className="menu-item"
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <span>Delete</span>
                  </div>
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>

          <div className="project-item-description">{project.description}</div>
          <div className="project-item-type">
            {project.type === 'classic' && <div className="classic-type">Normal</div>}
            {project.type === 'funding' && <div className="funding-type">Project Funding</div>}
          </div>
          <div className="project-item-created-date">{moment(project.createdAt).format('MM-DD-YYYY HH:mm:ss ')}</div>
        </div>
      </div>
    </div>
  );
};

export default ProjectItem;
